import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";

if (/[?&]ref=/.test(window.location.search)) void import("./lib/funnel").then((m) => m.captureCampaign());

const root = document.getElementById("root");
if (root) createRoot(root).render(<HelmetProvider><App /></HelmetProvider>);
